import { Configuration, UserAgentApplication } from 'msal';
import axios, { AxiosInstance } from 'axios';

const getSFToken: () => Promise<string> = async () => {
  const sfClient = axios.create({
    baseURL: 'https://fleet.solvas.be/api'
  });
  const response = await sfClient.post('/auth/login', {
    email: 'jasper@solvas.be',
    password: 'UdvYY&Kk75e'
  });
  const { access } = response.data;
  return access;
};

let sfToken: string;
export const getSFClient: () => Promise<AxiosInstance> = async () => {
  if (!sfToken) {
    sfToken = await getSFToken();
  }

  return axios.create({
    baseURL: 'https://fleet.solvas.be/api',
    headers: {
      Authorization: `Bearer ${sfToken}`
    }
  });
};

const config: Configuration = {
  auth: {
    clientId: '87ac4baa-23ae-4f01-8ae0-6eca2deda45b',
    authority:
      'https://login.microsoftonline.com/276b0202-a94c-4b1d-8d59-de6e5c55b282'
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  }
};

const msal = new UserAgentApplication(config);

export default msal;
